export default __webpack_public_path__ + "static/blob8-0cc459dd4f2461c6c3a3234ca31da2ad.svg";